export default __webpack_public_path__ + "static/media/logo.4b8c1931.png";